import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router";

import { useInvalidateUploadTaskQueries } from "@/queries/query-upload-task";

export const useAfterFormSubmit = () => {
  const navigate = useNavigate();
  const invalidateUploadTaskList = useInvalidateUploadTaskQueries();
  const toast = useToast();

  return async () => {
    toast({
      title: "Upload taak succesvol gestart.",
      status: "success",
      duration: 9000,
      isClosable: true,
    });

    navigate("/?viewType=uploadTasks");

    await invalidateUploadTaskList();
  };
};
